import { ClientLayerError } from 'shared/errors/clientLayerError'

/** Logged when ad preview send fails unexpectedly. */
export class AdPreviewSendFailedWarningError extends ClientLayerError {
  static readonly className: string = 'AdPreviewSendFailedWarningError'

  constructor(error?: unknown) {
    super(error ?? 'Ad preview send failed', {
      cause: error,
    })
    this.setMarkupOptions({ scope: 'marketing', section: 'engagement' })
    this.addFingerprintSegment('failed-to-send-ad-preview')
  }
}

/** Logged when custom audience check request fails unexpectedly. */
export class CustomAudienceCheckFailedWarningError extends ClientLayerError {
  static readonly className: string = 'CustomAudienceCheckFailedWarningError'

  constructor(error?: unknown) {
    super(error ?? 'Custom audience check failed', {
      cause: error,
    })
    this.setMarkupOptions({ scope: 'marketing', section: 'engagement' })
    this.addFingerprintSegment('failed-to-check-custom-audience')
  }
}

/** Logged when ad constructor is initialized while already loaded. */
export class AdConstructorAlreadyLoadedError extends ClientLayerError {
  static readonly className: string = 'AdConstructorAlreadyLoadedError'

  constructor() {
    super('Ad constructor is already loaded')
    this.setMarkupOptions({ scope: 'fb_ads', section: 'ad_constructor' })
    this.addFingerprintSegment('ad-constructor-already-loaded')
  }
}

/** Logged when custom audience creation fails. */
export class CreateCustomAudienceError extends ClientLayerError {
  static readonly className: string = 'CreateCustomAudienceError'

  constructor(error: unknown) {
    super(error, { cause: error })
    this.setMarkupOptions({ scope: 'fb_ads', section: 'custom_audience' })
    this.addFingerprintSegment('create-custom-audience')
  }
}

/** Logged when lookalike audience creation fails. */
export class CreateLookalikeAudienceError extends ClientLayerError {
  static readonly className: string = 'CreateLookalikeAudienceError'

  constructor(error: unknown) {
    super(error, { cause: error })
    this.setMarkupOptions({ scope: 'fb_ads', section: 'custom_audience' })
    this.addFingerprintSegment('create-lookalike-audience')
  }
}
